<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'App',
        // metaInfo() {
        //     return {
        //         title: "Page d'accueil | APaym Cabine",
        //         meta: [
        //             {
        //                 vmid: "description",
        //                 name: "description",
        //                 content:
        //                     "APaym Cabine est une plateforme qui vous permets de faire le rechargement de vos " +
        //                     "cartes Visa via les mobiles money, d'acheter du crédit téléphonique, de commander des cartes, " +
        //                     "de faire le rechargement de votre compte Yango, ainsi que le paiement de vos factures."
        //             }
        //         ]
        //     };
        // },
        data: () => ({}),
        watch: {
        }
    };
</script>
